module.exports = __webpack_public_path__ + "static/media/mypicture.e134bf94.jpg";